import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../api/apiClient';
import './LoginPage.css'; // Vi genbruger login stilen

const ResetPasswordPage = () => {
  const { token } = useParams(); // Hent token fra URL
  const navigate = useNavigate();
  
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Adgangskoderne er ikke ens');
      return;
    }
    if (password.length < 6) {
      setError('Adgangskoden skal være mindst 6 tegn');
      return;
    }

    try {
      setError(null);
      await apiClient.post('/api/auth/reset-password', { token, newPassword: password });
      setMessage('Adgangskode ændret succesfuldt! Du videresendes til login...');
      
      // Vent 2 sekunder og gå til login
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Kunne ikke nulstille koden. Linket kan være udløbet.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Ny Adgangskode</h1>
        <p className="login-subtitle">Vælg en ny stærk adgangskode</p>

        {error && <div style={{background:'#d32f2f', color:'white', padding:'10px', borderRadius:'4px', marginBottom:'1rem'}}>{error}</div>}
        {message && <div style={{background:'#2e7d32', color:'white', padding:'10px', borderRadius:'4px', marginBottom:'1rem'}}>{message}</div>}

        {!message && (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Ny Adgangskode</label>
              <input type="password" className="form-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <div className="form-group">
              <label className="form-label">Bekræft Adgangskode</label>
              <input type="password" className="form-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
            </div>
            <button type="submit" className="login-btn">Gem ny kode</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;